export default "__VITE_ASSET__6de21cd4__"